import { ROUTES } from "@/helpers/routes"
import { QuestTab } from "./ui"

export const QUESTS_TABS = [
  {
    segment: "quests",
    label: "quests.tabs.quests",
    path: ROUTES.QUESTS_LIST,
    Component: QuestTab
  }
] as const
